import { ReactComponent as FlagIcon } from "./svg/in-flag.svg";
import "../flag-icon.scss";

export const INFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
